let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bdBby")).then(() => parcelRequire('dl3sy'));